import { saveAs } from 'file-saver';
import { mapImmunizationResults } from '../api/mappers/immunizationResultMapper';
import { mapUserResults } from '../api/mappers/labResultMapper';
import * as vsApi from '../api/vsApi';
import { NO_IMMUNIZATION_RECORD_CODE } from '../api/vsApi';
import { ERROR_CONTEXT_IMMUNIZATION, ERROR_CONTEXT_PDF, ERROR_CONTEXT_RESULTS, ERROR_CONTEXT_VACCINATION_STATUS, handleErrors } from '../util/error';
import { getLanguageStrings } from '../util/language';

export const fetchLabResults = () => {
    return {
        type: "FETCH_LAB_RESULTS",
    }
}

export const receiveLabResults = (data) => {
    return {
        type: "RECEIVE_LAB_RESULTS",
        data: data,
    }
}

export const fetchImmunizationResults = () => {
    return {
        type: "FETCH_IMMUNIZATION_RESULTS",
    }
}

export const receiveImmunizationResults = (data) => {
    return {
        type: "RECEIVE_IMMUNIZATION_RESULTS",
        data: data,
    }
}

export const fetchVaccinationStatus = () => {
    return {
        type: "FETCH_VACCINATION_STATUS",
    }
}

export const receiveVaccinationStatus = (data) => {
    return {
        type: "RECEIVE_VACCINATION_STATUS",
        data: data,
    }
}

export const setUser = (data) => {
    return {
        type: "SET_USER",
        data: data,
    }
}

export const setDependents = (data) => {
    return {
        type: "SET_DEPENDENTS",
        data: data,
    }
}

export const setDependentsResults = (data) => {
    return {
        type: "SET_DEPENDENTS_RESULTS",
        data: data,
    }
}

export const setSelectedLabResult = (data) => {
    return {
        type: "SET_SELECTED_LAB_RESULT",
        data: data,
    }
}

export const errorFetching = (data) => {
    return {
        type: "FETCH_ERROR",
        error: data,
    }
}

export const setErrorState = (state, err, fetch) => {
    return {
        type: "SET_ERROR_STATE",
        state: state,
        error: err,
        fetch: fetch,
    }
}

export const setLogoutErrorState = (state, err, fetch) => {
    return {
        type: "SET_LOGOUT_ERROR_STATE",
        state: state,
        error: err,
        fetch: fetch,
    }
}

export const clearData = () => {
    return {
        type: "CLEAR_DATA",
    }
}

export const createDeviceId = () => {
    return {
        type: "CREATE_DEVICE_ID",
    }
}

export const setSelectedUser = (data) =>{
    return {
        type: "SET_SELECTED_USER",
        data: data,
    }
}

export const setMainScreen =(user,results)=>{
    return{
        type: "SET_MAIN_SCREEN",
        data: {user, results},
    }
}

export const setIsGettingResultsPDF = (data) =>{
    return{
        type: "SET_GETTING_PDF",
        data: data,
    }
}

export const setIsFetchingPvcPdf = (data) =>{
    return{
        type: "SET_FETCHING_PVC_PDF",
        data: data,
    }
}

export const parseJson = (response, language) => {
    const contentType = response.headers.get("content-type");
    const length = response.headers.get("content-length");
    if (contentType && contentType.indexOf("application/json") !==-1) {
        return response.json().then(results => ({ results: results, statusCode: response.status }));
    }
    else if (length !== 0 && contentType && contentType.indexOf("application/pdf") !== -1) {
        return response;
    }
    else {
        return response.text().then(text => {
            let strings = getLanguageStrings(language);
            console.log("status code: " + response.status + "\nresponse: " + text)
            throw new Error(strings.GATEWAY_NETWORK_ERROR + " " + response.status);
        })
    }
}

export const fetchLabResultsThunk = (userId) => {
    return function(dispatch, getState) {
        let fetching = getState().api.isLoadingLabResults;
        if (fetching !== true) {
            dispatch(fetchLabResults());
            let deviceId = getState().api.deviceId;
            let language = getState().language.language;
            let authorizationToken = getState().auth.authorizationToken;
            return vsApi.getResults(userId, deviceId, language, authorizationToken)
                .then((response) => {
                    return parseJson(response, language);
                })
                .then((obj) => {
                    let results = obj.results;
                    let statusCode = obj.statusCode;
                    let error = vsApi.handleGetResultsErrors(statusCode, results);
                    if (error.error === true) {
                        handleErrors(error, language, ERROR_CONTEXT_RESULTS);
                    }
                    return results;
                })
            .then((results) => {
                if(results.success){
                    let labResults = results.data.patientResults;
                    let mappedResults = mapUserResults(labResults);

                    dispatch(receiveLabResults(mappedResults));
                }
            })
            .catch((err) => {
                dispatch(setErrorState(true, err.message, true))
            })
        }
    }
}

export const doGetResultsPDF = (messageId, facilityNumber, resultDate, userId)=>{
    return function(dispatch, getState) {
        let fetching = getState().api.isGettingPDF;
        if (fetching !== true) {
            dispatch(setIsGettingResultsPDF(true));
            let deviceId = getState().api.deviceId;
            let language = getState().language.language;
            let authorizationToken = getState().auth.authorizationToken;
            let headers;
            let status;
            return vsApi.getResultsPDF(language, deviceId, authorizationToken, messageId, facilityNumber, resultDate, userId)
            .then(response => {
                status = response.status;
                headers = response.headers;
                return parseJson(response, language);
            })
            .then( async response =>{
                let contentType = headers.get("content-type");
                console.log(contentType);
                let length = headers.get("content-length");
                console.log(length);
                if(status === 200 && length!==0 && contentType!=="application/json;charset=UTF-8"){
                    let blob = await response.blob();
                    let contentDisposition = headers.get("content-disposition");
                    let fileName = contentDisposition.split("=")[1];

                    saveAs(blob, fileName);
                    dispatch(setIsGettingResultsPDF(false));
                } else{
                    let json = await response.json();
                    let strings = getLanguageStrings(language);
                    let error = vsApi.handleGetPDFErrors(status, json, length, contentType, strings);
                    if(error.error === true)
                        handleErrors(error, language, ERROR_CONTEXT_PDF);
                } 
            })
            .catch(err => {
                dispatch(setErrorState(true, err.message, true))
            });
        }
    }
}

export const fetchImmunizationResultsThunk = (userId) => {
    return function(dispatch, getState) {
        let fetching = getState().api.isLoadingImmunizationResults;
        let deviceId = getState().api.deviceId;
        // Now send this to vs auth api
        if (fetching !== true) {
            dispatch(fetchImmunizationResults());
            let language = getState().language.language;
            let authorizationToken = getState().auth.authorizationToken;
            // Fetch the data...
            return vsApi.getImmunizationResults(userId, language, deviceId, authorizationToken)
                .then((response) => {
                    return parseJson(response, language);
                })
                .then((obj) => {
                    let results = obj.results;
                    let statusCode = obj.statusCode;
                    // FIXME: rename this to a generic error handler
                    let error = vsApi.handleGetImmunizationErrors(statusCode, results);
                    if (error.error === true) {
                        handleErrors(error, language, ERROR_CONTEXT_IMMUNIZATION);
                    }
                    return results;
                })
                .then((results) => {
                    // Map whatever comes from the api into local model objects
                    if (results.data !== null && results.data.patientImmunization != null) {
                        console.warn(results.data)
                        let { user , sortedResults } = mapImmunizationResults(results.data.patientImmunization);
                        dispatch(receiveImmunizationResults(sortedResults));
                    } else if (results.data == null && results.error.exception === NO_IMMUNIZATION_RECORD_CODE) {
                        dispatch(receiveImmunizationResults([]))
                    }
                })
                .catch((err) => {
                    dispatch(setErrorState(true, err.message, true))
                });
        }
    }
}

export const fetchVaccinationResult = () => {
    return {
        type: "FETCH_VACCINATION_RESULT",
    }
}

export const getVaccinationStatus = (userId) => {
    return function(dispatch, getState) {
        let fetching = getState().api.isLoadingVaccinationStatus;
        if (fetching !== true) {
            dispatch(fetchVaccinationStatus());
            let deviceId = getState().api.deviceId;
            let language = getState().language.language;
            let authorizationToken = getState().auth.authorizationToken;
            return vsApi.getVaccinationStatus(userId, language, deviceId, authorizationToken)
                .then((response) => {
                    return parseJson(response, language);
                })
                .then((obj) => {
                    let results = obj.results;
                    let status = obj.statusCode;
                    let error = vsApi.handleGetVaccinationStatusError(status, results); 
                    if (error.error === true) {
                        handleErrors(error, language, ERROR_CONTEXT_VACCINATION_STATUS)
                    }
                    return results;
                })
                .then((results) => {
                    if (results.success) {
                        let vaccinationStatus = results.data.vaccinationStatus.vaccinationStatus;
                        dispatch(receiveVaccinationStatus(vaccinationStatus));
                    }
                })
                .catch(err => {
                    console.log("here")
                    dispatch(setErrorState(true, err.message, true))
                });
        }
    }
}

export const getImmunizationResultsPDF = (userId)=>{
    return function(dispatch, getState) {
        let fetching = getState().api.isGettingPDF;
        let filename = getState().api.user.firstName + "_" + getState().api.user.lastName + "_" + "Immunization_Record.pdf";
        if (fetching !== true) {
            dispatch(setIsGettingResultsPDF(true));
            let deviceId = getState().api.deviceId;
            let language = getState().language.language;
            let authorizationToken = getState().auth.authorizationToken;
            let headers;
            let status;
            let contentType;
            let length;
            return vsApi.getImmunizationResultsPDF(userId, language, deviceId, authorizationToken)
            .then(response => {
                status = response.status;
                headers = response.headers;
                contentType = headers.get("content-type");
                length = headers.get("content-length");
                return parseJson(response, language);
            })
            .then(async response =>{
                if(status === 200 && length!==0 && contentType!=="application/json;charset=UTF-8"){
                    let blob = await response.blob();
                    let contentDisposition = headers.get("content-disposition");
                    let fileName = contentDisposition.split("=")[1];
                    saveAs(blob, fileName);
                    dispatch(setIsGettingResultsPDF(false));
                } else{
                    let json = await response.json();
                    let strings = getLanguageStrings(language);
                    let error = vsApi.handleGetPDFErrors(status, json, length, contentType, strings);
                    if(error.error === true)
                        handleErrors(error, language, ERROR_CONTEXT_PDF);
                } 
            })
            .catch(err => {
                dispatch(setErrorState(true, err.message, true))
            });
        }
    }
}

export const getPvcPdf = (userId) => {
    return function(dispatch, getState) {
        let fetching = getState().api.isFetchingPvcPdf;
        if (fetching !== true) {
            dispatch(setIsFetchingPvcPdf(true));
            let deviceId = getState().api.deviceId;
            let language = getState().language.language;
            let authorizationToken = getState().auth.authorizationToken;
            let headers;
            let status;
            return vsApi.getPVCPDF(language, deviceId, authorizationToken, userId)
            .then(response => {
                status = response.status;
                headers = response.headers;
                return parseJson(response, language);
            })
            .then(async response =>{
                let contentType = headers.get("content-type");
                let length = headers.get("content-length");
                let strings = getLanguageStrings(language);
                let json = response.results;
                if(status === 200 && length !==0 && contentType!=="application/json;charset=UTF-8"){
                    let blob = await response.blob();
                    let contentDisposition = headers.get("content-disposition");
                    let  fileName = strings.PVC_PDF_FILENAME + contentDisposition.split("=")[1].split("_")[2];
                    saveAs(blob, fileName);
                    dispatch(setIsFetchingPvcPdf(false));
                } else{
                    let strings = getLanguageStrings(language);
                    let error = vsApi.handlePVCPDFErrors(status, json, length, contentType, strings);
                    if(error.error === true){
                        handleErrors(error, language, ERROR_CONTEXT_IMMUNIZATION);
                    }
                }
            })
            .catch(err => {
                dispatch(setErrorState(true, err.message, true))
            });
        }
    }
}